import { IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { colors } from "../../theme/theme";
import { SecondaryBtn } from "./CustomBtn";
import {
  East,
  Reply,
  Upload,
  West,
  TuneOutlined,
  FilterAltOutlined,
  CreditCard,
  TrendingUp,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCreators,
  getUserById,
  unSubscribeCreator,
} from "../../redux/actions/user.dispatcher";

const HeadingWithBtns = ({
  creator,
  analytics,
  back,
  title,
  calendar,
  noSubBtn = false,
  share = false,
  setCalenderComponentState,
  drawerState,
  setDrawerState,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const selectedTab = location.pathname;
  const mediumScreen = useMediaQuery("(max-width:960px)");
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { userData } = useSelector((state) => state.user);

  const isFollowing = creator?.id && userData?.following?.includes(creator.id);

  const handleUnsubscribe = async (id) => {
    try {
      const response = await unSubscribeCreator(id);
      dispatch(getAllCreators());
      dispatch(getUserById(userData.id));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Stack
      direction={mediumScreen ? "column" : "row"}
      sx={{
        justifyContent: mediumScreen ? "center" : "space-between",
      }}
    >
      <Stack
        direction={"row"}
        sx={{
          gap: smallScreen ? 2 : 1,
          alignItems: "center",
          justifyContent: smallScreen ? "space-between" : "",
        }}
      >
        {back && (
          <IconButton onClick={() => navigate(`/creator/${userData.id}`)}>
            <West sx={{ fontSize: "32px", color: "#000" }} />
          </IconButton>
        )}
        <Typography
          sx={{
            fontSize: smallScreen ? "23px" : "32px",
            fontFamily: "Inter-Bold",
            color: colors.textColor,
          }}
        >
          {title ? title : `Welcome Back, ${userData?.firstName}`}
        </Typography>
        {smallScreen && selectedTab == "/dashboard" && (
          <Stack direction={"row"} sx={{ gap: 1, alignItems: "center" }}>
            <TuneOutlined />
            <FilterAltOutlined
              onClick={() => {
                setCalenderComponentState(true);
              }}
            />
          </Stack>
        )}
        {smallScreen && selectedTab !== "/dashboard" && (
          <Stack direction={"row"} sx={{ gap: 1, alignItems: "center" }}>
            {!calendar && (
              <IconButton
                onClick={() => {
                  navigate("/creator/content-analytics");
                }}
                sx={{
                  opacity: 1,
                }}
              >
                <TrendingUp sx={{ opacity: 1, color: "#000" }} />
              </IconButton>
            )}
            {/* <IconButton
              onClick={() => {
                navigate("/creator/subscriptions");
              }}
            >
              <CreditCard sx={{ opacity: 1, color: "#000" }} />
            </IconButton> */}
          </Stack>
        )}
      </Stack>

      {/* {creator ? (
        <>
          {userData?.creatorId === null && !smallScreen && (
            <SecondaryBtn
              text={"I want to be Creatora"}
              Icon={East}
              width={mediumScreen ? "100%" : "20%"}
              noMb
              noMt={!mediumScreen}
              onClick={() => navigate("/creator/form")}
            />
          )}
        </>
      ) : share ? (
        <Stack
          direction={"row"}
          sx={{
            gap: 1,
            alignItems: "center",
            width: mediumScreen ? "100%" : "50%",
            justifyContent: "flex-end",
            mt: mediumScreen ? 2 : 0,
          }}
        >
          <SecondaryBtn
            text="Share"
            Icon={Reply}
            width={mediumScreen ? "50%" : "20%"}
            noMb
            noMt
            black
          />
          <SecondaryBtn
            text={"I want to be Creatob"}
            Icon={East}
            width={mediumScreen ? "50%" : "30%"}
            noMb
            noMt
            onClick={() => navigate("/creator/form")}
          />
        </Stack>
      ) : (
        <Stack
          direction={"row"}
          sx={{
            gap: 1,
            alignItems: "center",
            width: mediumScreen ? "100%" : "50%",
            justifyContent: mediumScreen ? "flex-start" : "flex-end",
            mt: mediumScreen ? 2 : 0,
            flexWrap: mediumScreen ? "wrap" : "nowrap",
          }}
        >
          {userData?.creatorId === null ? (
            <SecondaryBtn
              text={"I want to be Creatorc"}
              Icon={East}
              width={mediumScreen ? "100%" : "40%"}
              noMb
              noMt={!mediumScreen}
              onClick={() => navigate("/creator/form")}
            />
          ) : (
            <>
              {analytics && !smallScreen && (
                <SecondaryBtn
                  text={"Content Analytics"}
                  Icon={East}
                  width={mediumScreen ? "45%" : noSubBtn ? "40%" : "50%"}
                  noMb
                  noMt
                  onClick={() => navigate("/creator/content-analytics")}
                />
              )}
              {!noSubBtn && !smallScreen && (
                <SecondaryBtn
                  text={"Manage Subscriptions"}
                  Icon={East}
                  width={mediumScreen ? "50%" : analytics ? "60%" : "40%"}
                  noMb
                  noMt
                  onClick={() => navigate("/creator/subscriptions")}
                />
              )}
              {!smallScreen && (
                <SecondaryBtn
                  text={"Upload Content"}
                  Icon={Upload}
                  width={
                    smallScreen
                      ? "100%"
                      : mediumScreen
                      ? "50%"
                      : noSubBtn
                      ? "40%"
                      : analytics
                      ? "60%"
                      : "40%"
                  }
                  noMb
                  noMt
                  filled
                  onClick={() => navigate("/creator/upload-content")}
                />
              )}
            </>
          )}
        </Stack>
      )} */}
    </Stack>
  );
};

export default HeadingWithBtns;
